import { render, staticRenderFns } from "./ArtistShows.vue?vue&type=template&id=150888c8&scoped=true"
import script from "./ArtistShows.vue?vue&type=script&lang=js"
export * from "./ArtistShows.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "150888c8",
  null
  
)

export default component.exports